import type { ReactNode } from "react";

import CalloutInfoIcon from "@/components/icons/CalloutInfoIcon";
import CalloutTipIcon from "@/components/icons/CalloutTipIcon";
import CalloutWarningIcon from "@/components/icons/CalloutWarningIcon";

const VARIANTS = {
  info: {
    container: "border-gail-primary bg-blue-50",
    icon: (
      <CalloutInfoIcon
        className="h-5 w-5 shrink-0 text-gail-primary"
        aria-hidden="true"
      />
    ),
  },
  warning: {
    container: "border-amber-500 bg-amber-50",
    icon: (
      <CalloutWarningIcon
        className="h-5 w-5 shrink-0 text-amber-600"
        aria-hidden="true"
      />
    ),
  },
  tip: {
    container: "border-emerald-500 bg-emerald-50",
    icon: (
      <CalloutTipIcon
        className="h-5 w-5 shrink-0 text-emerald-600"
        aria-hidden="true"
      />
    ),
  },
} as const;

type CalloutType = keyof typeof VARIANTS;

interface CalloutProps {
  type?: CalloutType;
  children: ReactNode;
}

export function Callout({ type = "info", children }: Readonly<CalloutProps>) {
  const variant = VARIANTS[type];

  return (
    <div
      className={`not-prose my-6 flex gap-3 rounded-lg border-l-4 p-4 ${variant.container}`}
      role={type === "warning" ? "alert" : "note"}
    >
      <div className="pt-0.5">{variant.icon}</div>
      <div className="prose prose-sm min-w-0">{children}</div>
    </div>
  );
}
